import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Icon24 from 'builder/components/Icon'

export const TextContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const SectionContainer = styled.div`
  background: ${Colors.White};
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 20px;
  margin-bottom: 3px;
  gap: 64px;
  padding: 32px;

  ${Media.Phone`
    gap: 48px;
  `}
`

export const VideoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex: 1;
`

export const Section = styled.div`
  display: flex;
  flex: 1;
  width: 100%;

  ${Media.Phone`
    flex-direction: column;
  `}
`

export const VideoSection = styled.div`
  display: flex;
  flex: 1;
  width: 100%;

  ${Media.Phone`
    flex-direction: column-reverse;
  `}
`

export const BadgeContainer = styled.div`
  flex: 1;

  ${Media.Phone`
    margin-bottom: 24px;
  `}
`

export const SectionTextContainer = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
  flex: 1;

  ${Media.Phone`
    gap: 16px;
  `}
`

export const SectionSubtitle = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral60};
`

export const ShowMoreLess = styled.div`
  display: inline-flex;
  ${Typography.ButtonV2M};
  ${FontWeights.Medium};
  color: ${Colors.Neutral100};
  cursor: pointer;
  gap: 4px;
`

export const ChevronDown = styled(Icon24.Chevron)`
  color: ${Colors.Neutral100};
  transform: rotate(90deg);
`

export const ChevronUp = styled(Icon24.Chevron)`
  color: ${Colors.Neutral100};
  transform: rotate(270deg);
`
